import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { 
  TrendingUp, Flame, BarChart3, Users, Target
} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ICON_MAP = {
  'trending-up': TrendingUp,
  'flame': Flame,
  'bar-chart': BarChart3,
  'users': Users,
  'target': Target,
};

const COLOR_MAP = {
  emerald: 'bg-emerald-50 border-emerald-200 text-emerald-700',
  orange: 'bg-orange-50 border-orange-200 text-orange-700',
  blue: 'bg-blue-50 border-blue-200 text-blue-700',
  indigo: 'bg-indigo-50 border-indigo-200 text-indigo-700',
  teal: 'bg-teal-50 border-teal-200 text-teal-700',
};

const ICON_COLOR_MAP = {
  emerald: 'text-emerald-600',
  orange: 'text-orange-600',
  blue: 'text-blue-600',
  indigo: 'text-indigo-600',
  teal: 'text-teal-600',
};

const SmartInsights = () => {
  const { getAuthHeaders } = useAuth();
  const [insights, setInsights] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/engagement/insights`, { headers: getAuthHeaders() });
        setInsights(res.data.insights || []);
      } catch {}
    };
    fetch();
  }, []);

  if (insights.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="smart-insights">
      <h3 className="font-semibold text-slate-900 text-sm flex items-center gap-2">
        <BarChart3 size={16} className="text-[#2272C5]" />Your Insights
      </h3>
      {insights.map((insight, i) => {
        const Icon = ICON_MAP[insight.icon] || TrendingUp;
        const colorClass = COLOR_MAP[insight.color] || COLOR_MAP.blue;
        const iconColor = ICON_COLOR_MAP[insight.color] || ICON_COLOR_MAP.blue;
        return (
          <Card key={i} className={`border ${colorClass}`} data-testid={`insight-${insight.type}`}>
            <CardContent className="p-3 flex items-center gap-3">
              <Icon size={18} className={iconColor} />
              <p className="text-sm font-medium">{insight.message}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default SmartInsights;
